import { SortableHeader, SortableHeadersGroup } from 'components/Shared';
import { PaginatedDriver } from 'contracts/Drivers';
import { SortingParams } from 'contracts/Common';
import React, { useCallback } from 'react';
import { Formatter } from 'utils';
import * as S from './styles';

interface Props {
  drivers: PaginatedDriver[];
  onSort?: (sort: SortingParams) => void;
  currentSort: SortingParams;
}

interface ItemProps {
  driver: PaginatedDriver;
}

export const DriversList: React.FC<Props> = ({
  drivers,
  onSort,
  currentSort,
}) => {
  const Item = useCallback(({ driver }: ItemProps): JSX.Element => {
    const { id, name, document, cellPhone } = driver;

    return (
      <S.ListItem>
        <S.Column>{id}</S.Column>
        <S.Column>{name}</S.Column>
        <S.Column>{Formatter.document(document)}</S.Column>
        <S.Column>{Formatter.cellPhone(cellPhone)}</S.Column>
        <S.ActionsColumn>
          <S.LinkActionButton to={`/configuracoes/motoristas/${id}/editar`}>
            <S.EditIcon />
          </S.LinkActionButton>
        </S.ActionsColumn>
      </S.ListItem>
    );
  }, []);

  return (
    <S.List>
      <S.ListHeader>
        <SortableHeadersGroup onSort={onSort} currentSort={currentSort}>
          <SortableHeader column="id" label="ID" />
          <SortableHeader column="name" label="NOME" />
          <SortableHeader column="document" label="DOCUMENTO" />
          <SortableHeader column="cellPhone" label="CELULAR" />
        </SortableHeadersGroup>
      </S.ListHeader>
      {drivers.map((driver) => (
        <Item key={driver.id} driver={driver} />
      ))}
    </S.List>
  );
};
